import { connect } from "preact-redux";
import MapComponent from "./component";

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(MapComponent);



// WEBPACK FOOTER //
// ./components/activities-map/index.js